var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('contact-form',{attrs:{"name":_vm.name,"required-fields":_vm.requiredFields}},[_c('contact-fields',{attrs:{"exclude":_vm.exclude}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }